import { graphql } from "@/graphql/codegen"

graphql(`
  fragment CustomerPurchaseOrderListItemFields on CustomerPurchaseOrderListItem {
    customerPurchaseOrderId
    publicId
    status
    cpoNumber
    createdOn
    shippingDate
    uomId
    pallets
    units
    quantityInUom
  }
`)

graphql(`
  fragment CustomerPurchaseOrderBaseFields on CustomerPurchaseOrder {
    customerPurchaseOrderId
    companyId
    shipToLocationId
    cpoNumber
    publicId
    status
    createdOn
  }
`)

// AK-5934 — CPO product line, including the Sales Order auto-assigned/created on save
graphql(`
  fragment CustomerPurchaseOrderProductLineFields on CustomerPurchaseOrderProductLine {
    id
    uomId
    shippingDate
    isShipAsap
    deliverDate
    isDeliverAsap
    shipFromWarehouseAreaId
    pallets
    units
    quantityInUom
    pricePerUom
    priceUomId
    salesOrderId
    salesOrder {
      salesOrderId
      publicId
      status
    }
  }
`)

graphql(`
  fragment CustomerPurchaseOrderProductFields on CustomerPurchaseOrderProduct {
    id
    productId
    pallets
    units
    quantityInUom
    uomId
    product {
      productId
      externalSystemId
      publicId
      companyProductDescription
      vendorDescription
      computedProductStatus
      ...ProductPackageWeightFields
      company {
        name
      }
    }
    lines {
      ...CustomerPurchaseOrderProductLineFields
    }
  }
`)
